import React from 'react';
import { FadeIn, SectionTitle, Card } from '../components/UI';

export default function PrivacyPage() {
  return (
    <div style={{ paddingTop: 100, background: 'var(--dark)' }}>
      <section style={{ padding: '60px 40px 100px', maxWidth: 1000, margin: '0 auto' }}>
        <FadeIn>
          <SectionTitle subtitle="Legal" title="Privacy Policy" />
        </FadeIn>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <Card>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              Effective date: 26 February 2026.
            </p>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              KNOWIT SOLUTIONS is committed to protecting your personal information. This policy explains what data we collect
              through this website, how we use it, and your rights.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>What we collect</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              When you submit the contact form, we collect: name, email address, optional company name, and message content.
              We also collect basic technical/diagnostic information required to operate and secure the service.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>How we use your data</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              We use submitted data to respond to enquiries, provide requested services, maintain service reliability,
              and improve website performance. We do not sell your personal data.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>Data storage and security</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              Contact submissions are stored in our SQL database and processed through our hosted application stack.
              We apply technical and organisational safeguards appropriate to the nature of the data.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>Your rights</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              Subject to applicable law, you may request access, correction, deletion, or restriction of your personal data.
              You may also object to certain processing and request data portability where available.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>Contact</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75, marginBottom: 0 }}>
              For privacy enquiries, contact us at hello@knowitsolutions.co.uk.
            </p>
          </Card>
        </div>
      </section>
    </div>
  );
}
